<template>
  <v-col class="d-flex flex-column text-center">
    <v-img eager contain :src="item.image_illustration" class="mb-10" style="max-height: 400px" />
    <div class="text-tcdc-green sub-header1 bold mb-3">{{item[`title_${lang}`]}}</div>
    <div class="mb-3 vhtml" v-html="item[`intro_${lang}`]"></div>
    <div class="text-center">
      <GreenButton :label="$t('our-service.readmore')" @click.native="eventClick" />
    </div>
  </v-col>
</template>

<script>
import GreenButton from "../buttons/GreenButton";
import {mapState} from "vuex";
export default {
  components: {
    GreenButton
  },
  props: {
    item: {
      required: true
    }
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang,
    })
  },
  methods: {
    eventClick() {
      this.$emit('onPress');
    }
  }
};
</script>

<style scoped>

</style>
